import React from "react";

import { Box, Typography } from "@mui/material";

import { WorkflowStepProps } from "./type";

export const WorkflowStep: React.FC<WorkflowStepProps> = ({
  title,
  content,
  StepImage,
}) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    rowGap={1}
    p={3}
    pb={4}
  >
    <StepImage width={140} height={140} />
    <Typography variant="h5" component="h3" align="center">
      {title}
    </Typography>
    {content.length === 1 && (
      <Typography variant="subtitle1" component="p">
        {content[0]}
      </Typography>
    )}
    {content.length > 1 && (
      <Box component="ul" style={{ listStyleType: "disc", paddingLeft: 22 }}>
        {content.map((item, index: number) => (
          <Typography variant="subtitle1" component="li" key={index}>
            {item}
          </Typography>
        ))}
      </Box>
    )}
  </Box>
);
